var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_totaluser",
    transform: "translate(45 -33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(-45 33)",
    fill: "rgba(3,209,207,0.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(-30 42)",
    fill: "#303fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_34",
    "data-name": "Intersection 34",
    d: "M22895,786V768a5,5,0,0,1,5-5h12v18a5,5,0,0,1-5,5Z",
    transform: "translate(-22925 -721)",
    fill: "#50d0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M5.786-1.427A3.861,3.861,0,0,0,9.644-5.285,3.861,3.861,0,0,0,5.786-9.142,3.861,3.861,0,0,0,1.929-5.285,3.861,3.861,0,0,0,5.786-1.427Zm27,0a3.861,3.861,0,0,0,3.858-3.858,3.861,3.861,0,0,0-3.858-3.858,3.861,3.861,0,0,0-3.858,3.858A3.861,3.861,0,0,0,32.789-1.427ZM34.718.5H30.86a3.846,3.846,0,0,0-2.718,1.121,8.817,8.817,0,0,1,4.527,6.594h3.978a1.927,1.927,0,0,0,1.929-1.929V4.359A3.861,3.861,0,0,0,34.718.5ZM19.288.5a6.747,6.747,0,0,0,6.751-6.751A6.747,6.747,0,0,0,19.288-13a6.747,6.747,0,0,0-6.751,6.751A6.747,6.747,0,0,0,19.288.5ZM23.917,2.43h-.5a9.495,9.495,0,0,1-4.129.964,9.515,9.515,0,0,1-4.129-.964h-.5A6.945,6.945,0,0,0,7.715,9.374V11.11A2.894,2.894,0,0,0,10.608,14H27.967A2.894,2.894,0,0,0,30.86,11.11V9.374A6.945,6.945,0,0,0,23.917,2.43ZM10.433,1.623A3.846,3.846,0,0,0,7.715.5H3.858A3.861,3.861,0,0,0,0,4.359V6.288A1.927,1.927,0,0,0,1.929,8.217H5.9A8.839,8.839,0,0,1,10.433,1.623Z",
    transform: "translate(-40.287 54.499)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.ae09b3105674952ee8d92dcf16d22d1f.svg";
export { ForwardRef as ReactComponent };